<style scoped>
.detail_menu {
  width: 200px;
  height: 500px;
}

.detail_menu,
.detail_info {
  display: inline-block;
  vertical-align: top;
}

.detail_info {
  height: 500px;
}
.course {
  margin-left: 6px;
  color: #ccc;
  font-size: 14px;
}

.courseTi {
  margin-left: 6px;
  font-size: 13px;
  color: #000;
}
</style>
<template>
  <div>
    <!-- <div style="font-size: 16px;line-height: 40px;padding-left: 25px;">{{$route.query.courseTitle+' / '+$route.query.sectionName}}</div> -->
    <div class="course_div">
      <span @click="back()"
        style="cursor: pointer;font-size: 14px;line-height: 40px;padding-left: 15px;">{{$route.query.courseTitle}}</span>
      <span v-if="$route.query.sectionName" class="course">/</span>
      <span class="courseTi">{{$route.query.sectionName}}</span>
    </div>
    <Row>
      <Col span="4">
      <ul class="ivu-menu ivu-menu-light ivu-menu-vertical">
        <li v-for="item in detailMenu" :key="item.val"
          :class="`ivu-menu-item ivu-menu-item-selected ${item.val === $route.meta.detailActive?'ivu-menu-item-active':''}`"
          @click="changeMenuItem(item.val)">{{item.name}}</li>
        <!-- <li class="ivu-menu-item ivu-menu-item-selected ivu-menu-item-active">章节内容</li>
        <li class="ivu-menu-item ivu-menu-item-selected">step列表</li>
        <li class="ivu-menu-item ivu-menu-item-selected">手帐资料</li>
        <li class="ivu-menu-item ivu-menu-item-selected">家长指南</li>
        <li class="ivu-menu-item ivu-menu-item-selected">打卡内容</li>
        <li class="ivu-menu-item ivu-menu-item-selected">课程报告</li> -->
      </ul>
      <!-- <Menu @on-select="changeMenuItem" theme="light" :active-name="$route.meta.detailActive" style="width: 100%">
        <MenuItem name="2">
        章节内容
        </MenuItem>
        <MenuItem name="3">
        step列表
        </MenuItem>
        <MenuItem name="4">
        手帐资料
        </MenuItem>
        <MenuItem name="5">
        家长指南
        </MenuItem>
        <MenuItem name="7">
        打卡内容
        </MenuItem>
        <MenuItem name="6">
        课程报告
        </MenuItem>

      </Menu> -->
      </Col>
      <Col span="20">
      <router-view v-on:changeSectionType="changeSectionType" :type-num="typeNum"></router-view>
      </Col>
    </Row>
  </div>
</template>
<script>
import { Menu, Submenu, MenuItem } from "iview";
// import { mapGetters } from "vuex";
import http from "../../libs/http.js";
const detailMenu = [
  { val: "2", name: "章节内容" },
  { val: "3", name: "step列表" },
  { val: "4", name: "手帐资料" },
  { val: "5", name: "家长指南" },
  { val: "7", name: "打卡内容" },
  { val: "6", name: "课程报告" },
];
export default {
  data() {
    return {
      courseId: this.$route.query.courseId,
      sectionId: this.$route.query.sectionId,
      typeNum: "",
      detailMenu,
    };
  },
  created: function () {
    this.getSection();
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    getSection() {
      let that = this;
      if (that.sectionId) {
        that.loading = true;
        http
          .post("/custom/section/list", {
            sectionId: that.sectionId,
            courseId: that.courseId,
          })
          .then((res) => {
            that.loading = false;
            that.typeNum = res.sectionType;
          });
      }
    },
    changeSectionType(dataType) {
      this.typeNum = dataType;
    },
    changeMenuItem(name) {
      this.$Modal.confirm({
        title: "提示",
        content: "请先检查是否已经保存修改内容",
        okText:'已保存-跳转',
        cancelText:'未保存-继续编辑',
        onOk: () => {
          let query = {
            courseStatus: this.$route.query.courseStatus,
            courseId: this.$route.query.courseId,
            sectionId: this.$route.query.sectionId,
            courseTitle: this.$route.query.courseTitle,
            sectionName: this.$route.query.sectionName,
            page: this.$route.query.page,
          };
          let replaceObj = {
            path:'',
            query
          }
          switch (name) {
            case "2":
              replaceObj.path = "editSection"
              break;
            case "3":
              replaceObj.path = "step"
              break;
            case "4":
              replaceObj.path = "pf"
              break;
            case "5":
              replaceObj.path = "parentClass"
              break;
            case "6":
              replaceObj.path = "report"
              break;
            case "7":
              replaceObj.path = "signIn"
              break;
          }
          this.$router.replace(replaceObj)
        },
      });
    },
  },
  components: {
    Menu,
    Submenu,
    MenuItem,
  },
};
</script>